import { render, staticRenderFns } from "./contractmanagement.vue?vue&type=template&id=04b2134d"
import script from "./contractmanagement.vue?vue&type=script&lang=js"
export * from "./contractmanagement.vue?vue&type=script&lang=js"
import style0 from "./contractmanagement.vue?vue&type=style&index=0&id=04b2134d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports